import React from 'react';
import block from 'propmods';

import './Switch.scss';

const b = block('Switch');

interface Item {
    value: string;
    text: string;
    title?: string;
    disabled?: boolean;
}

interface SwitchProps {
    items: Item[];
    value: string;
    onSwitch: (value: string) => void;
}

interface SwitchState {
    sliderOffset: number | null;
    sliderWidth: number | null;
    isAnimated?: boolean;
}

export default class Switch extends React.Component<SwitchProps, SwitchState> {
    public itemElements: HTMLDivElement[];

    constructor(props: SwitchProps) {
        super(props);
        this.itemElements = [];
        this.state = {
            sliderOffset: null,
            sliderWidth: null,
            isAnimated: false,
        };
    }

    public setSliderPosition(cb?: () => void) {
        let i = 0;

        for (const item of this.props.items) {
            if (item.value === this.props.value) {
                break;
            }

            i++;
        }

        this.setState(
            {
                sliderOffset: this.itemElements.slice(0, i).reduce((total, current) => total + current.clientWidth, 0),
                sliderWidth: this.itemElements[i].clientWidth,
            },
            cb,
        );
    }

    public handleSwitch = (value: string) => {
        if (this.props.onSwitch) {
            this.props.onSwitch(value);
        }
    };

    public componentDidMount() {
        setTimeout(() => {
            this.setSliderPosition(() => this.setState({ isAnimated: true }));
        }, 0);
    }

    public componentDidUpdate(prevProps: SwitchProps) {
        if (prevProps !== this.props) {
            this.setSliderPosition();
        }
    }

    public render() {
        const { value } = this.props;
        const items = this.props.items.map((item, i) => {
            const selected = item.value === value;
            const disabled = item.disabled;

            const clickable = !selected && !disabled;

            return (
                <div
                    {...b('item', { selected, disabled })}
                    onClick={() => clickable && this.handleSwitch(item.value)}
                    title={item.title}
                    key={item.value}
                    ref={(el) => (this.itemElements[i] = el!)}
                >
                    {item.text}
                </div>
            );
        });

        return (
            <div {...b()}>
                <div
                    {...b('slider', { animated: this.state.isAnimated })}
                    style={{
                        left: this.state.sliderOffset || 0,
                        width: this.state.sliderWidth || 0,
                    }}
                />
                <div {...b('items')}>{items}</div>
            </div>
        );
    }
}
